<div class="tw-block tw-w-full" [class.tw-flex-1]="flexInRow()" [class.tw-min-w-0]="flexInRow()">
@if (label()) {
  <label
    [attr.for]="triggerId"
    class="tw-block tw-font-medium tw-text-gray-700 tw-font-inter"
    [ngClass]="{
      'tw-text-xs tw-mb-2': labelTextSize() === 'xs',
      'tw-text-sm tw-mb-1': labelTextSize() === 'sm',
    }"
    >{{ label() }}</label>
}
<app-dropdown
  #timeDropdown
  [id]="dropdownDomId"
  class="tw-w-full"
  [componentWithDataSetter]="panelConfig()"
  [dropdownListXPosition]="'right'"
  [dropdownListYPosition]="'bottom'"
  [maxHeightInPX]="340"
  [widthInPX]="'186px'"
  [exceptionSelector]="'.event-time-picker-dropdown-panel'"
  (dropdownOpened)="dropdownOpen.set(true)"
  (dropdownClosed)="dropdownOpen.set(false)"
>
  <div
    role="button"
    tabindex="0"
    [id]="triggerId"
    [attr.aria-expanded]="dropdownOpen()"
    aria-haspopup="dialog"
    [attr.aria-controls]="panelId"
    (click)="$event.stopPropagation()"
    class="tw-inline-flex tw-bg-gray-50 tw-w-full tw-cursor-pointer tw-items-center tw-rounded-lg tw-border tw-border-gray-300 tw-px-3 tw-font-inter tw-text-left tw-transition-colors focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-blue-500 focus-visible:tw-ring-offset-2"
    [class.tw-h-12]="fixedHeight()"
    [class.tw-py-2.5]="!fixedHeight()"
    [class.tw-border-red-600]="invalid()"
    [class.tw-border-gray-300]="!invalid()"
  >
    <span class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2 tw-text-sm tw-font-inter tw-text-gray-500">
      <span class="tw-flex tw-min-w-0 tw-flex-1 tw-items-baseline tw-justify-start tw-gap-0">
        <input
          #hourInput
          type="text"
          inputmode="numeric"
          autocomplete="off"
          spellcheck="false"
          maxlength="2"
          placeholder="00"
          aria-label="Hours"
          class="tw-w-5 tw-text-center tw-min-w-0 tw-flex-none tw-bg-transparent tw-border-0 tw-p-0 tw-m-0 tw-outline-none tw-ring-0 tw-shadow-none tw-text-sm tw-font-inter tw-text-gray-500 tw-tabular-nums tw-text-left placeholder:tw-text-gray-400"
          [value]="hourText()"
          (click)="onSegmentClick($event)"
          (focus)="onHourFocus($event)"
          (input)="onHourInput($any($event.target).value)"
          (blur)="onHourBlur()"
          (keydown)="onHourKeydown($event)"
        />
        <span class="tw-shrink-0 tw-select-none tw-pointer-events-none tw-tabular-nums tw-text-gray-500" aria-hidden="true">:</span>
        <input
          #minuteInput
          type="text"
          inputmode="numeric"
          autocomplete="off"
          spellcheck="false"
          maxlength="2"
          placeholder="00"
          aria-label="Minutes"
          class="tw-w-5 tw-text-center tw-min-w-0 tw-flex-none tw-bg-transparent tw-border-0 tw-p-0 tw-m-0 tw-outline-none tw-ring-0 tw-shadow-none tw-text-sm tw-font-inter tw-text-gray-500 tw-tabular-nums tw-text-left placeholder:tw-text-gray-400"
          [value]="minuteText()"
          (click)="onSegmentClick($event)"
          (focus)="onMinuteFocus($event)"
          (input)="onMinuteInput($any($event.target).value)"
          (blur)="onMinuteBlur()"
          (keydown)="onMinuteKeydown($event)"
        />
      </span>
      @if (showClockIcon()) {
        <button type="button" class="tw-shrink-0 tw-flex tw-items-center tw-justify-center" (click)="openFromClockIcon($event)">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12C4.81331 12 3.65328 11.6481 2.66658 10.9888C1.67989 10.3295 0.910851 9.39246 0.456725 8.2961C0.0025997 7.19975 -0.11622 5.99335 0.115291 4.82946C0.346802 3.66557 0.918247 2.59648 1.75736 1.75736C2.59648 0.918247 3.66557 0.346802 4.82946 0.115291C5.99335 -0.11622 7.19975 0.0025997 8.2961 0.456725C9.39246 0.910851 10.3295 1.67989 10.9888 2.66658C11.6481 3.65328 12 4.81331 12 6C11.9983 7.59076 11.3656 9.11587 10.2407 10.2407C9.11587 11.3656 7.59076 11.9983 6 12ZM6 1.2C5.05065 1.2 4.12262 1.48152 3.33326 2.00895C2.54391 2.53638 1.92868 3.28604 1.56538 4.16312C1.20208 5.04021 1.10702 6.00533 1.29223 6.93644C1.47744 7.86754 1.9346 8.72282 2.60589 9.39411C3.27718 10.0654 4.13246 10.5226 5.06357 10.7078C5.99468 10.893 6.9598 10.7979 7.83688 10.4346C8.71397 10.0713 9.46362 9.45609 9.99105 8.66674C10.5185 7.87738 10.8 6.94935 10.8 6C10.7986 4.7274 10.2924 3.50733 9.39254 2.60747C8.49267 1.7076 7.2726 1.20143 6 1.2Z" fill="#6B7280"/>
            <path d="M6 6.6C5.84087 6.6 5.68826 6.53679 5.57574 6.42427C5.46322 6.31174 5.4 6.15913 5.4 6V3.6C5.4 3.44087 5.46322 3.28826 5.57574 3.17574C5.68826 3.06322 5.84087 3 6 3C6.15913 3 6.31174 3.06322 6.42427 3.17574C6.53679 3.28826 6.6 3.44087 6.6 3.6V6C6.6 6.15913 6.53679 6.31174 6.42427 6.42427C6.31174 6.53679 6.15913 6.6 6 6.6Z" fill="#6B7280"/>
            <path d="M7.965 8.565C7.80588 8.56497 7.6533 8.50173 7.5408 8.3892L5.57574 6.42427C5.46644 6.3111 5.40603 6.15948 5.4074 6.00216C5.40876 5.84484 5.47187 5.69436 5.58311 5.58311C5.69436 5.47187 5.84484 5.40876 6.00216 5.4074C6.15948 5.40603 6.31104 5.46651 6.4242 5.5758L8.3892 7.5408C8.47309 7.62471 8.53021 7.73161 8.55335 7.84798C8.57649 7.96435 8.56461 8.08497 8.51921 8.19459C8.47381 8.30421 8.39692 8.39791 8.29828 8.46384C8.19963 8.52977 8.08365 8.56498 7.965 8.565Z" fill="#6B7280"/>
          </svg>
        </button>
      }
    </span>
  </div>
</app-dropdown>
</div>
